export const normalizeLinks = (links = []) => links.map((url) => {
  const value = url.trim();
  return value && !/^[a-z][a-z0-9+.-]*:/i.test(value)
    ? `https://${value.replace(/^\/\//, "")}` : value;
}).filter(Boolean);

export const linksAreValid = (links = []) => normalizeLinks(links).every((value) => {
  try {
    const url = new URL(value);
    return !/\s/.test(value) && ["http:", "https:"].includes(url.protocol) && url.hostname.includes(".") && value.length <= 500;
  } catch { return false; }
});

